import { TurmaModel } from '@/models/academico/professor/turma.model';
import { GradeHorarioProfessor } from '@/models/academico/professor/gradehorario.model'
import { EnsinoSerieDisciplina } from '@/models/academico/escola/ensino_serie_disciplina.model'
import api from '@/services/axios/api';
import toastService from "../../globals/toast.service";
import { useStore } from "@/store"
import sessionService from "@/services/helper/session.service";
import { MapeamentoProfessorDisciplina, MapeamentoProfessorDisciplinaOutput } from '@/models/academico/professor/mapeamento_disciplinas.model';
import { BNCC_RCG, BNCC_RCG_PlanejamentoProfessor } from '@/models/academico/BNCC/BNCC.model';
import { LoginAppInfo } from '@/models/academico/professor/login_app_info';
import apiKernel from '@/services/axios/api.kernel';

class ProfessorService {
    codigoEscola: string | null = '';
    codigoProfessor: string | null = '';
    ano: string | null = '';
    semestre: string | null = '';

    constructor() {
        this.initialize();
    }

    initialize() {
        this.codigoEscola = useStore().getters.getCodigoEscola;

        if (sessionService.IsProfessor() || useStore().getters.getChamadaViaProxy) {
            console.log('ehProfessor');
            this.codigoProfessor = useStore().getters.getCodigoProfessor;
        }
        else {
            console.log('não é ehProfessor');
            this.codigoProfessor = useStore().getters.getCodigoProfessorSelecionadoTelaFiltro;
        }

        this.ano = useStore().getters.getAno;
        this.semestre = useStore().getters.getSemestre;
    }

    async getTurmasProfessor(codigoPessoal: number): Promise<TurmaModel[]> {
        try {
            const result = await api.get<TurmaModel[]>(`/Professor/${codigoPessoal}/Turmas`);
            return result.data;
        } catch (exception) {
            toastService.alertaErro("Erro ao carregar dados de Turmas do Professor!");
            return Promise.reject(exception);
        }
    }

    async getGradeHorarioProfessor(codigoPessoal: number): Promise<GradeHorarioProfessor[]> {
        try {
            this.initialize();
            const result = await api.get<GradeHorarioProfessor[]>(`/Professor/${codigoPessoal}/GradeHorario`);
            return result.data;
        } catch (exception) {
            toastService.alertaErro("Erro ao carregar Grade de Horários do Professor!");
            return Promise.reject(exception);
        }
    }

    async getEnsinoSerieDisciplina(): Promise<EnsinoSerieDisciplina[]> {
        try {
            this.initialize();
            const result = await api.get<EnsinoSerieDisciplina[]>(`/Escola/${this.codigoEscola}/EnsinosSeriesDisciplinas/${this.ano}`);
            return result.data;
        } catch (exception) {
            toastService.alertaErro("Erro ao carregar Grade de Horários do Professor!");
            return Promise.reject(exception);
        }
    }

    async getListaMapeamentoProfessorDisciplina(): Promise<MapeamentoProfessorDisciplinaOutput[]> {
        try {
            this.initialize();
            const result = await api.get<MapeamentoProfessorDisciplinaOutput[]>(`/Professor/MapeamentoDisciplina/${this.codigoEscola}/${this.ano}`);
            return result.data;
        } catch (exception) {
            toastService.alertaErro("Erro ao carregar lista de mapeamento de professor/disciplina!");
            return Promise.reject(exception);
        }
    }

    async inserirMapeamentoProfessorDisciplina(dados: MapeamentoProfessorDisciplina): Promise<any> {
        try {
            this.initialize();
            dados.codigoEscola = parseInt(this.codigoEscola ?? "0");
            dados.ano = parseInt(this.ano ?? "0");
            await api.post('/Professor/MapeamentoDisciplina', dados);
        }
        catch (exception: any) {
            return exception.response.data;
        }
    }

    async excluirMapeamentoProfessorDisciplina(codigo: number): Promise<any> {
        try {
            await api.delete(`/Professor/MapeamentoDisciplina/${codigo}`);
        }
        catch (exception: any) {
            return exception.response.data;
        }
    }

    async obterBNCC_RCG(codigoTurma: number, codigoDisciplina: number, codigoEtapa: number): Promise<BNCC_RCG[]> {
        try {
            this.initialize();
            const response = await api.get(`/BNCC/BNCC_RCG/${this.codigoEscola}/${this.ano}/${this.codigoProfessor}/${codigoTurma}/${codigoDisciplina}/${codigoEtapa}`);
            return response.data;
        } catch (exception) {
            toastService.alertaErro("Erro ao buscar Habilidades!");
            return Promise.reject(exception);
        }
    }

    async obterLoginAppInfo(): Promise<LoginAppInfo[]> {
        try {
            this.initialize();
            const response = await apiKernel.get(`/Users/LoginAppInfo/${this.codigoProfessor}`);
            return response.data;
        } catch (exception) {
            toastService.alertaErro("Erro ao buscar informações de login do app!");
            return Promise.reject(exception);
        }
    }

    async salvarMarcacaoBNCC_RCG(payload: {
        codigoHabilidade: string;
        marcado: boolean;
        etapa: number;
        codigoTurma: number;
        codigoDisciplina: number;
    }) {
        this.initialize();
        const body = {
            ...payload,
            codigoEscola: this.codigoEscola,
            ano: this.ano,
            codigoProfessor: this.codigoProfessor
        };
        return api.post('/BNCC/BNCC_RCG/SalvarMarcacaoBNCC_RCG', body);
    }


    async salvarMarcacaoRCG(payload: {
        codigoHabilidadeRCG: string;
        marcado: boolean;
        codigoHabilidadeBNCC: string;
        etapa: number;
        codigoTurma: number;
        codigoDisciplina: number;
    }) {
        this.initialize();
        const body = {
            ...payload,
            codigoEscola: this.codigoEscola,
            ano: this.ano,
            codigoProfessor: this.codigoProfessor
        };
        return api.post('/BNCC/BNCC_RCG/SalvarMarcacaoRCG', body);
    }

    async retornarPlanejamentoProfessorBNCC_RCG(codigoTurma: number, codigoDisciplina: number, codigoEtapa: number): Promise<BNCC_RCG_PlanejamentoProfessor[]> {
        try {
            this.initialize();
            const response = await api.get(`/BNCC/BNCC_RCG/PlanejamentoProfessor/${this.codigoEscola}/${this.ano}/${this.codigoProfessor}/${codigoTurma}/${codigoDisciplina}/${codigoEtapa}`);
            return response.data;
        } catch (exception) {
            toastService.alertaErro("Erro ao buscar Planejamento!");
            return Promise.reject(exception);
        }
    }
}
export default new ProfessorService();